module.exports = __webpack_public_path__ + "img/gallery-image-2.b59a061e.jpg";